module.exports = __webpack_public_path__ + "static/media/emptycart.93e4764d.gif";